<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <form>
          <card>
            <template slot="header">
              <h3 class="card-title">Messaging</h3>
            </template>

            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-12">
                    <h4>Send emails to:</h4>
                    <radio name="to_type"
                           inline
                           value="all_applicant_users"
                           v-model="message.to_type"
                    >
                      <span class="ml-2">All applicant users</span>
                    </radio>
                    <radio name="to_type" inline value="all_application_users" v-model="message.to_type">
                      <span class="ml-2">All users with applications</span>
                    </radio>
                    <radio name="to_type" inline value="email" v-model="message.to_type">
                      <span class="ml-2">To specific email</span>
                    </radio>

                    <textarea
                      class="textarea-email mt-3"
                      v-if="message.to_type === 'email'"
                      placeholder="Write one or more emails here, comma separated"
                      v-model="messageEmail.email"
                    >
            </textarea>

                  </div>
                </div>

                <div v-if="message.to_type !== 'email'">
                  <p class="mt-3">* Application will send the emails according to user language prefference</p>

                  <div class="mt-5" v-for="language in languages" :key="language.language">
                    <div class="row">
                      <div class="col-lg-12">
                        <div>
                          <label>
                            <flag :iso="language.flag" v-bind:squared=false></flag>
                            {{language.languageName}}:</label>
                        </div>

                        <div class="row">
                          <div class="col-lg-12">
                  <textarea
                    class="subject"
                    :placeholder="'Your subject here for ' + language.languageName + ' users '"
                    v-model="message.subject[language.language]"
                  >
            </textarea>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg-12">
                  <textarea
                    :placeholder="'Your message here for ' + language.languageName + ' users '"
                    v-model="message.body[language.language]"
                  >
            </textarea>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="message.to_type === 'email'" class="mt-5">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-12">
                  <textarea
                    class="subject"
                    :placeholder="'Your subject here'"
                    v-model="messageEmail.subject"
                  >
            </textarea>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-12">
                  <textarea
                    :placeholder="'Your message here'"
                    v-model="messageEmail.body"
                  >
            </textarea>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

              <div class="col-lg-6">
                <div class="mail-sample-image text-center">
                  <h4>Sample email:</h4>
                  <img src="/img/messaging_mail.png">
                </div>
              </div>
            </div>

            <template slot="footer">
              <base-button v-if="message.to_type === 'email'" @click="sendEmail" type="primary" size="lg" class="btn-fill">
                Send email
              </base-button>

              <base-button v-if="message.to_type !== 'email'" @click="sendNotification" type="primary" size="lg" class="btn-fill">
                Send notification to users
              </base-button>
            </template>
          </card>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import {TabPane, Tabs} from 'src/components';
  import {LocalizationService, MessagingService} from '@/services';
  import swal from 'sweetalert2';

  export default {
    components: {
      TabPane,
      Tabs
    },
    data() {
      return {
        languages: {},
        message: {
          to_type: 'all_application_users',
          subject: {},
          body: {},
        },
        messageEmail: {
          subject: '',
          body: '',
          email: ''
        }
      }
    },
    methods: {
      async sendNotification() {
        let vm = this;
        let validMessages = false;
        Object.keys(vm.message.body).forEach(function (item) {
          if (vm.message.body[item] !== undefined && vm.message.body[item].length > 0) {
            validMessages = true;
          }
        })

        if (!validMessages) {
          alert('You must enter message in at least one language!');
          return;
        }

        let validSubjects = true;
        Object.keys(vm.message.subject).forEach(function (item) {
          if (vm.message.subject[item] !== undefined && vm.message.subject[item].length > 0) {
            validSubjects = true;
          }
        })

        if (!validSubjects) {
          alert('You must enter subject in at least one language!');
          return;
        }

        if(!confirm('Are you sure you want to proceed by sending emails to users?')) {
          return false;
        }

        let loader = this.$loading.show();

        let response = await MessagingService.sendNotification(vm.message);

        let total_recipients = response.data.total_recipients;
        if (response.data.success === true) {
          swal({
            title: this.$t('general.notification__success'),
            text: 'Your message was sent to ' + total_recipients + ' recipients.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        }

        loader.hide();
      },
      async sendEmail() {
        let vm = this;

        if (!vm.messageEmail.subject.length) {
          alert('You must enter subject!');
          return;
        }

        if (!vm.messageEmail.body.length) {
          alert('You must enter subject!');
          return;
        }

        let loader = this.$loading.show();
        let response = await MessagingService.sendEmail(vm.messageEmail);

        let total_recipients = response.data.total_recipients;
        if (response.data.success === true) {
          swal({
            title: this.$t('general.notification__success'),
            text: 'Your message was sent to ' + total_recipients + ' recipients.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        }

        loader.hide();
      },
    },
    async beforeCreate() {
      let loader = this.$loading.show();
      await LocalizationService.getLanguages().then((response) => {
        this.languages = response.data;
      }).catch((error) => {

      })

      loader.hide();
    }
  };
</script>
<style lang="scss" scoped>
  .lang-input {
    width: 80%;
  }

  .flag-icon {
    font-size: 1.5rem;
  }

  .mail-sample-image {
    img {
      max-width: 80%;
    }
  }

  textarea {
    width: 100%;
    resize: both;
    max-height: none !important;
    height: 150px;

    &.subject, &.textarea-email {
      height: auto !important;
      width: 100%;
    }
  }
</style>
